import React from 'react'
import { useTranslation } from '../../hooks';
import './_footer.scss'

function Footer() {
  const { i18n } = useTranslation();
  const poweredBy = i18n('cp_powered_by_zinier');
  const termsHref = i18n('terms_and_conditions_link');
  const termsLabel = i18n('cp_terms_label');
  const privacyHref = i18n('privacy_policy_link');
  const privacyLabel = i18n('cp_privacy_policy_label');

  const isSafeUrl = (url) => /^https?:\/\//i.test(url);
  const elements = [
    poweredBy && <span key="powered">{poweredBy}</span>,
    termsHref && isSafeUrl(termsHref) && termsLabel && <a key="terms" href={termsHref} target="_blank" rel="noreferrer">{termsLabel}</a>,
    privacyHref && isSafeUrl(privacyHref) && privacyLabel && <a key="privacy" href={privacyHref} target="_blank" rel="noreferrer">{privacyLabel}</a>,
  ].filter(Boolean);

  if (!elements.length) return null;

  return (
    <footer className='footer' role="contentinfo">
      <small className='copyright'>
        {elements.map((el, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span>&nbsp; • &nbsp;</span>}
            {el}
          </React.Fragment>
        ))}
      </small>
    </footer>
  )
}

Footer.propTypes = {}

export default Footer
